import { ZoneProperties } from '../model/zone-properties';

export const ZONE_PROPERTIES_DEFAULT: ZoneProperties = 
    {
        id:null,
        name:null,
        color:null,
        type:null,
        thermal:{
            ifActive:false,
            selected:null
        },
        acoustic:{
            ifActive:false,
            selected:null
        },
        rainNoise:{
            ifActive:false,
            selectedWork:null,
            selectedRoom:null,
            roomHeight:null,
        },
        compresiveStrength:{
            ifActive:false,
            selected:null
        },
        pointLoad:{
            ifActive:false,
            selected:null
        }
    }

